import React, {useState} from 'react'
import {useTranslation} from "react-i18next";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import {Chip, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useDispatch} from "react-redux";
import {
    default_card_client_secret,
    default_card_client_secret_admin,
    Logout,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UserCarrierEdit from "../../profile/userInformation/UserCarrierEdit";
import EditIcon from "@mui/icons-material/Edit";
import {cargoOwnerInfo} from "../../../actions/inventory/inventoryAction";
import LocalStorage from "../../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {userWHMpCfgInfo} from "../../../actions/userWHMp/userWHMpAction";
import MDButton from "../../../components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "../../system/payment/CheckoutForm";
import {loadStripe} from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_PK);

const splitSendEmails = (value) => (
    value
        ?.split(/[,;]+/)
        .map((email) => email.trim())
        .filter(Boolean) || []
)

const invoiceTermLabels = {
    '1': 'Daily Settlement',
    '7': 'Weekly Settlement',
    '15': 'Semimonthly Settlement',
    '30': 'Monthly Settlement',
}

const getInvoiceTermLabel = (value) => {
    if (value === null || value === undefined || value === '') return ''
    const text = value.toString().trim()
    return invoiceTermLabels[text] || text
}

const sendEmailLabels = {Y: 'Yes', N: 'No'}
const accountTypeLabels = {
    INDIVIDUAL: 'B2B Owner',
    ENTERPRISE: 'B2C Owner(include B2B)',
}

const OwnerCargoInfo = ({info,setOpenCarrierEdit,loading,setOpenStorageFeeTermEdit}) => {

    const [isOpen,setIsOpen] = useState(true)
    const {t,i18n} = useTranslation()
    const dispatch = useDispatch()
    const nav = useNavigate()

    const [isAddingCard,setIsAddingCard] = useState(false)
    const [clientSecret, setClientSecret] = useState(null)
    const [customerId, setCustomerId] = useState('');
    const [currency,setCurrency] = useState('CAD')
    const [cardMenuAnchorEl, setCardMenuAnchorEl] = useState(null);
    const cardMenuOpen = Boolean(cardMenuAnchorEl);

    const options = {
        // passing the client secret obtained from the server
        clientSecret: clientSecret,
        locale: i18n.language
    };

    const handleOpenCardMenu = (event) => {
        setCardMenuAnchorEl(event.currentTarget);
    };

    const handleCloseCardMenu = () => {
        setCardMenuAnchorEl(null);
    };

    const saveFormData = () => {
        let formData = {}
        formData.ownerId = info?.ocpOwnerId
        formData.username = info?.userName
        return formData
    }

    const handleSelectCardCurrency = (currency) => {
        handleCloseCardMenu();
        handleAddDefaultCard(currency);
    };
    const onClientSecretSuccess = (data) => {
        setIsAddingCard(true)
        setClientSecret(
            data?.clientSecret)
        setCustomerId(data?.customerId);
    }

    const handleAddDefaultCard = async (currency) => {
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
            setCurrency(currency)
        } else {
            return nav('/')
        }
        await dispatch(default_card_client_secret_admin(formData, onClientSecretSuccess, onError))
    }

    const onCancel = () =>{
        setIsAddingCard(false)
        setCustomerId('')
        setClientSecret(null)
    }

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }


    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },
        {
            id: 4,
            value: 'T',
            label: 'TERMINATED'
        },

    ]

    const storageFeePaymentTermArr = [
        {
            id: 1,
            value: '1',
            label: `${t(`Monthly`)}`
        },
        {
            id: 2,
            value: '2',
            label: `${t('Weekly')}`
        },


    ]


    return(<React.Fragment>
        <Card  sx={{minWidth: 350}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {t('CustomerPage.Cargo Owner Basic Information')}
                </MDTypography>
                <IconButton color={'white'}  disabled={loading}  size={'small'} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen&& !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        {
                            checkPermission(PERMISSION_DICT.AccountCustomerInfo)&&
                            <Grid item mb={1} xs={12} md={12} lg={12}  sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                                <MDButton
                                    disabled={!info?.ocpOwnerId}
                                    sx={{height:"30px"}}
                                    variant="gradient" color="info" size="small"
                                    startIcon={<AddIcon sx={{fontSize: "40px"}}/>}
                                    onClick={handleOpenCardMenu}
                                >
                                    {t('AccountPage.add Default card')}
                                </MDButton>
                                <Menu
                                    anchorEl={cardMenuAnchorEl}
                                    open={cardMenuOpen}
                                    onClose={handleCloseCardMenu}
                                >
                                    <MenuItem onClick={() => handleSelectCardCurrency("CAD")}>
                                        {t("AccountPage.ADD CARD (CAD)")}
                                    </MenuItem>
                                    <MenuItem onClick={() => handleSelectCardCurrency("USD")}>
                                        {t("AccountPage.ADD CARD (USD)")}
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        }
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.User Name')}:
                                </MDTypography>
                                {info?.userName && info?.userName!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.userName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.userName}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Active Status', 'Active Status')}:
                                </MDTypography>
                            </MDBox>
                            <Chip
                                size="small"
                                label={activeArr.find(item => item.value === info?.activeFlag)?.label || info?.activeFlag || ''}
                                color={info?.activeFlag === 'Y' ? 'success' : info?.activeFlag === 'N' ? 'error' : info?.activeFlag === 'T' ? 'default' : 'info'}
                                sx={info?.activeFlag === 'T' ? { backgroundColor: '#374151', color: '#fff' } : undefined}
                                sx={{
                                    height: 18,
                                    fontSize: 10,
                                    fontWeight: 900,
                                }}
                            />
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OCP Owner ID')}:
                                </MDTypography>
                                {info?.ocpOwnerId && info?.ocpOwnerId!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.ocpOwnerId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ocpOwnerId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OMS Owner ID')}:
                                </MDTypography>
                                {info?.omsOwnerId && info?.omsOwnerId!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.omsOwnerId)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.omsOwnerId}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.OMS Owner Type')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.omsOwnerType}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Payment Term')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.paymentTerm}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Invoice Term')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {getInvoiceTermLabel(info?.invoiceTerm || info?.settlementPeriod)}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    Send Email Requirement:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {sendEmailLabels[info?.isSendEmail] || info?.isSendEmail || ''}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    Account Type:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {accountTypeLabels[info?.accountType] || info?.accountType || ''}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid data-testid="cargo-owner-preview-basic-invoice-term" item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Account Manager')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.accountManager}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('SignUpPage.Company Name')}:
                                </MDTypography>
                                {info?.companyName && info?.companyName!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.companyName)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.companyName}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Allow Split Order')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.allowSplitOrder === 'N'?"NO":info?.allowSplitOrder === 'Y'?"YES":''}
                                </MDTypography>
                            </MDBox>
                        </Grid>



                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Financer Email')}:
                                </MDTypography>
                                {info?.financerEmail && info?.financerEmail!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.financerEmail)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.financerEmail}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Send Email', 'Send Email')}:
                                </MDTypography>
                                {info?.sendEmail && info?.sendEmail!=='NOT PROVIDED' && <Tooltip title={t("Copy")} placement={'right'} onClick={()=> handleClickCopy(info?.sendEmail)}>
                                    <IconButton aria-label="copy" size="small" color="primary">
                                        <ContentCopyIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip> }
                            </MDBox>
                            <MDBox>
                                <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                    {splitSendEmails(info?.sendEmail).map((email) => (
                                        <Chip
                                            key={email}
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                            label={email}
                                        />
                                    ))}
                                </MDBox>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Solution Rank')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.solutionRank}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Consumption Amount')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.consumptionAmount}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Current Version')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.currentVersion}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Description 1')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ownerDesc1}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Description 2')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.ownerDesc2}
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Carriers')}:
                                </MDTypography>
                            </MDBox>
                            {checkPermission(PERMISSION_DICT.CustomerCargoInfo) &&
                                <MDBox
                                style={{cursor: "pointer", alignItems: "center",width: "100px",}}
                                onClick={() => {
                                    dispatch(cargoOwnerInfo({ ownerId: info?.ocpOwnerId,
                                        userName: LocalStorage.getItem('username')}))

                                    setOpenCarrierEdit(true)
                                }}
                            >

                                    <MDTypography variant="button" fontWeight="regular" color="primary">
                                    &nbsp;{t('CustomerPage.View Details')}
                                </MDTypography>
                            </MDBox>}
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.Storage Fee Term')}:
                                </MDTypography>
                            </MDBox>
                            {
                                // checkPermission(PERMISSION_DICT.CustomerCargoInfo) &&
                                <MDBox
                                >
                                    <MDBox sx={{
                                        display: "flex",
                                        fontSize: "15px",
                                        cursor: "pointer",
                                        alignItems: "center",
                                        width: "80px",
                                    }}
                                           onClick={() => {
                                               // dispatch(cargoOwnerInfo({ ownerId: info?.ocpOwnerId,
                                               //     userName: LocalStorage.getItem('username')}))
                                               //
                                               if (checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify))
                                               {
                                                   setOpenStorageFeeTermEdit(true)
                                               }
                                           }}
                                    >
                                        <MDTypography variant="button" fontWeight="regular" color="primary">
                                            {/*{storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm)?.label}*/}
                                            {storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm)?storageFeePaymentTermArr.find((e)=>e.value===info?.storageFeeTerm).label:storageFeePaymentTermArr[0].label}
                                        </MDTypography>
                                        {
                                            checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify)&& <Icon>edit</Icon>
                                        }
                                    </MDBox>
                                </MDBox>}
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.CAD Card Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.cadCreditCardBindingStatus}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item mb={1} xs={12} md={6} lg={2.4}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                    {t('CustomerPage.USD Card Status')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.usdCreditCardBindingStatus}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} mb={1}>
                            <MDBox>
                                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                                    {t('CustomerPage.Note Text')}:
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                <MDTypography variant="button" color="text" fontWeight="regular">
                                    {info?.noteText}
                                </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            </Collapse>
        </Card>

        <Dialog
            open={isAddingCard}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("CustomerPage.Bind Credit Card")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Grid item xs={12} md={12} xl={12} p={3}>

                        {clientSecret &&
                            <Elements stripe={stripePromise} options={options}>
                                <CheckoutForm info={info} customerId={customerId} defaultBtnAdded={isAddingCard} setDefaultBtnAdded={setIsAddingCard} onCancel={onCancel} currency={currency} />
                            </Elements>
                        }

                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>

    </React.Fragment>)
}

export default OwnerCargoInfo
